'use strict';

var _ = require('lodash');
var ConfigurationParametersController = function ConfigurationParametersController($scope, dataProvider, configurationService, featureToggleService, userSecureService, SystemConstants) {
  var APP_NAME_TO_TYPE_MAPPING = {
    'Revenue Optimizer': 'REVENUE_OPTIMIZER',
    'Fares Optimizer': 'FARES_OPTIMIZER',
    'Dynamic Availability': 'DYNAMIC_AVAILABILITY',
    'Basic Parameters': 'SIMPLE_HEP'
  };
  $scope.selected = {};
  $scope.hepTypeList = getHepList();
  $scope.selectedHepType = $scope.hepTypeList[0];
  $scope.configType = getConfigType();
  $scope.getSelectedTitle = function () {
    if (!$scope.isSelected()) {
      return '';
    }
    if ($scope.isSimpleHepMode()) {
      return $scope.selected.hierarchy;
    }
    return dataProvider.getLabelFromType($scope.selected.type, $scope.configType) + ' / ' + dataProvider.createHierarchyLabel($scope.selected.hierarchy, $scope.selected.type, {
      titleShort: false
    }, $scope.configType);
  };
  $scope.getInfoTooltipContent = function () {
    return $scope.isSelected() ? configurationService.getInfoTooltipMessage($scope.selected.type) : '';
  };
  $scope.isSelected = function () {
    return !_.isEmpty($scope.selected);
  };
  $scope.updateHepType = function () {
    $scope.configType = getAppType($scope.selectedHepType);
  };
  $scope.isSimpleHepMode = function () {
    return $scope.configType === 'SIMPLE_HEP';
  };
  $scope.customAddNew = function (row) {
    if ($scope.selected.type === 'FOTaxOverride') {
      row.taxOverridePriority = 'HIGH';
    } else if ($scope.selected.type === 'FOTacticalFBCPatternConfig') {
      var extractedSeasons = configurationService.extractSeasonDetails();
      row.seasons = extractedSeasons.seasons;
      row.seasonsAbbreviationMap = extractedSeasons.seasonsAbbreviationMap;
      row.seasonDefinitions = extractedSeasons.seasonDefinitions;
    } else if ($scope.selected.type === 'FOAdvancePurchaseGrouping') {
      row.ladderGenerationAPCheck = 'TRUE';
    } else if ($scope.selected.type === 'FOBusinessRules') {
      row.recommendationMatchType = 'ALL';
    }
    return row;
  };
  function getAppType(selectedHepType) {
    return APP_NAME_TO_TYPE_MAPPING[selectedHepType];
  }
  function getConfigType() {
    var hepTypeList = $scope.hepTypeList;
    if (hepTypeList.length > 0) {
      return getAppType(hepTypeList[0]);
    }
    return 'SIMPLE_HEP';
  }
  function getUserPrivilege(privilegeName) {
    var component = privilegeName === SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.SYSTEM_PARAMETER ? SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.SYSTEM_PARAMETER : SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.SYSTEM_PARAMETER_ADVANCED_HEP;
    return _.find(userSecureService.getUserPrivileges(), {
      component: component
    }) || userSecureService.isCurrentUserAnAdmin();
  }
  function getHepList() {
    var hepTypeList = [];
    var simpleHepPrivilege = getUserPrivilege(SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.SYSTEM_PARAMETER);
    var advancedHepPrivilege = getUserPrivilege(SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.SYSTEM_PARAMETER_ADVANCED_HEP);
    if (simpleHepPrivilege) {
      hepTypeList.push('Basic Parameters');
    }
    if (featureToggleService.isEnabled('REVENUE_OPTIMIZER') && advancedHepPrivilege) {
      hepTypeList.push('Revenue Optimizer');
    }
    if (featureToggleService.isEnabled('DYNAMIC_AVAILABILITY') && advancedHepPrivilege) {
      hepTypeList.push('Dynamic Availability');
    }
    if (featureToggleService.isEnabled('FARES_OPTIMIZER') && advancedHepPrivilege) {
      hepTypeList.push('Fares Optimizer');
    }
    return hepTypeList;
  }
};
ConfigurationParametersController.$inject = ['$scope', 'ConfigurationParametersAdvancedDataProviderService', 'ConfigurationParametersAdvancedService', 'FeatureToggleService', 'UserSecureService', 'SystemConstants'];
module.exports = ConfigurationParametersController;